import React, { useContext, useEffect } from 'react'
import { ProductContext } from '../ProductProvider'
import { Link } from 'react-router-dom'
import './Welcome.css'
import { RoutesLocal } from '../routes'
import crest from '../assets/images/logo/arlogo.png'

export default function Welcome(){
  const { loggedUser, myProfileImage, validateLogin } = useContext(ProductContext)
  const name = loggedUser?.name || 'Guest'
  const role = loggedUser?.profile || (loggedUser?.isAdmin ? 'Admin' : 'User')
  const image = myProfileImage ? (myProfileImage.startsWith('http') ? myProfileImage : myProfileImage) : '/assets/img/logo.png'

      useEffect(() => {
        if(loggedUser.isAuthenticated){
        //  fetchGalleryImages();
        }else{
          validateLogin();
        }
      }, [loggedUser])  

  return (
    <main id="main" className="main welcome-main">
      <section className="welcome-hero container">
        <div className="welcome-card" style={{ '--crest-url': `url(${crest})` }}>
          <div className="welcome-media">
            <img src={crest} alt="Profile" className="welcome-avatar"/>
          </div>
          <div className="welcome-content">
            <h1 className='school-name-modern'>Welcome to Archive's Admin</h1>
            <p className="lead">Hello <strong>{name}</strong> — managing the archive's content just got easier. Use the dashboard to view insights, manage website content, and keep things running smoothly.</p>

            <div className="welcome-meta">
              <div className="meta-item">
                <div className="meta-label">Role</div>
                <div className="meta-value">{role}</div>
              </div>
              <div className="meta-item">
                <div className="meta-label">Email</div>
                <div className="meta-value">{loggedUser?.email || '—'}</div>
              </div>
            </div>

            <div className="welcome-actions">
              <Link to={RoutesLocal.DashboardOverview.path} className="btn btn-primary btn-lg">Go to Dashboard</Link>
              <Link to={RoutesLocal.MyProfile.path} className="btn btn-outline-secondary btn-lg">View Profile</Link>
            </div>

            <p className="welcome-note">Quick links: Slider, Gallery, Flash News are available in the left navigation.</p>
          </div>
        </div>
      </section>
    </main>
  )
}
